module.exports = __webpack_public_path__ + "img/shoethumb.b7a567a7.jpg";